import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NgControl,
  NgModel,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-plus-minus',
  templateUrl: './input-plus-minus.component.html',
  styleUrls: ['./input-plus-minus.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPlusMinusComponent),
      multi: true,
    },
  ],
})
export class InputPlusMinusComponent
  implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy
{
  @ViewChild('input', { static: false }) public input: NgModel;
  @Input() public min = 0;
  @Input() public max = 9999;

  public readonly faMinusCircle = faMinusCircle;
  public readonly faPlusCircle = faPlusCircle;

  private control: NgControl;
  private sub: Subscription;

  private _value = 0;
  public get value(): number {
    return isNaN(this._value) ? this.min : this._value;
  }

  public set value(v: number) {
    this._value = isNaN(v) ? this.min : v;
    this.writeValue(this._value);
  }

  constructor(
    private injector: Injector,
    private cd: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.control = this.injector.get(NgControl, new FormControl());
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.value = this.control.value;
    }, 0);

    // check outside change value
    this.sub = this.control.control.valueChanges.subscribe((val) => {
      // tslint:disable-next-line:triple-equals
      if (this.value != val) {
        this.value = val;
      }
      this.cd.detectChanges();

      setTimeout(() => {
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }, 100);
    });
  }

  public ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public decrement() {
    if (this.value <= this.min) {
      return;
    }

    this.value--;
  }

  public increment() {
    if (this.value >= this.max) {
      return;
    }

    this.value++;
  }

  public writeValue(value) {
    let v = value;
    let neadReset = false;
    if (value && !/^\d+$/.test(v)) {
      v = Number.parseInt(value, 10);
      neadReset = true;
    }
    v = isNaN(v) ? this.min : v;
    if (this.max && this.max < v) {
      v = this.max;
      neadReset = true;
    }
    if ((this.min || this.min === 0) && this.min > v) {
      v = this.min;
      neadReset = true;
    }
    if (neadReset) {
      this.input.reset(v);
    }
    this._value = v;
    this.onChange(v);
  }

  public onChange: any = () => {};
  public onTouched: any = () => {};

  public registerOnChange(fn) {
    this.onChange = fn;
  }

  public registerOnTouched(fn) {
    this.onTouched = fn;
  }
}
